import { CustomError } from 'core/errors';
import { DocumentsType } from '../core/document-types/document-types.model';

export const docTypes: DocumentsType[] = [
  { id: 'CI', desc: 'Cedula de Identidad', length: '8' },
  { id: 'EXT', desc: 'Extranjero', length: '10' },
  { id: 'RUC', desc: 'Registro unico contribuyentes', length: '11' },
];

export const DOC_TYPES_GET = {
  URL: `/api/servicios_fijos/v1/document_types`,
  OK_REPLY: { documentsType: docTypes },
  FAIL_REPLY: CustomError.createClientError({ description: 'No documents' }),
};
